import React from "react";
import PaidAndBookedEvents from '../../components/User/PaidAndBookedEvents'
import BookedEvents from '../../models/BookedEvents';
import RestUtilities, { IRestResponse } from '../../services/RestUtilities';
import PaymentTypes from '../../models/PaymentTypes';
import { FilterModel } from './BookedEvents'
import { Snackbar } from '@mui/material';
import SnackbarWrapper from '../../components/SnackbarWrapper';
import Auth from '../../stores/Auth';
import Loader from '../../components/Loader';
import { GrowMessage } from "../../components/GrowMessage";

class PaidEvents extends React.Component<any, any> {

    state = {
        payedEvents: [] as BookedEvents[],
        paymentTypes: [] as PaymentTypes[],
        filter: new FilterModel(),
        showError: false,
        errorMessage: '',
        loading: false
    }

    handleChangeFilter = (event: any): void => {
        const newFilter = {...this.state.filter}
        const fieldName = event.target.name

        newFilter[fieldName] = event.target.value

        this.setState({ filter: newFilter })
    }

    handleFilterEvents = (): void => {
        this.fetchPayedEvents(this.state.filter.eventName, 
            this.state.filter.bookingDateFrom, 
            this.state.filter.bookingDateTo, 
            this.state.filter.paymentTypeId)
    }

    handleClearFilter = (): void => {
        this.setState({ filter: new FilterModel() })
        this.fetchPayedEvents()
    }

    fetchPayedEvents = (eventName: string = '',
        bookingDateFrom: Date = null,
        bookingDateTo: Date = null,
        paymentTypeId: number = null): void => {
        
        this.setState({ loading: true })

        let personalNr = Auth.getPersonalNr()
        let url = `/api/ListBookedEvents?personalNr=${personalNr}&payed=true&`

        if (eventName !== '')
            url += `eventName=${eventName}`
        if (bookingDateFrom !== null) {
            let date = new Date(bookingDateFrom)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateFrom=${dateString}&`
        }
        if (bookingDateTo !== null) {
            let date = new Date(bookingDateTo)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateTo=${dateString}&`
        }
        if (paymentTypeId !== null)
            url += `paymentTypeId=${paymentTypeId}`

        RestUtilities.get<BookedEvents[]>(url)
            .then(resp => {
                this.setState({ payedEvents: resp.content, loading: false })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    fetchPaymentTypes = (): void => {
        RestUtilities.get<PaymentTypes[]>('/api/PaymentTypes')
            .then(resp => {
                this.setState({ paymentTypes: resp.content })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    showError = (resp: IRestResponse<BookedEvents>): void => {
        if(typeof resp.error_content != 'undefined' && resp.error_content) {
            this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
        }
    }

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showError:false })
    }

    componentDidMount() {
        this.fetchPayedEvents()
        this.fetchPaymentTypes()
    }

    public render() {
        return (

            <>
                <h2 className='title'>Bezahlte Veranstaltungen</h2>
                <PaidAndBookedEvents
                    events={this.state.payedEvents}
                    paymentTypes={this.state.paymentTypes}
                    filter={this.state.filter}
                    filterChange={this.handleChangeFilter}
                    handleFilter={this.handleFilterEvents}
                    clearFilters={this.handleClearFilter}
                />
                <GrowMessage
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    message={this.state.errorMessage}
                    visible={this.state.showError}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                ></GrowMessage>  
                {/* <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.showError}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                >
                    <SnackbarWrapper
                        onClose={this.handleSnackbarClose}
                        variant="success"
                        message={this.state.errorMessage}
                    />
                </Snackbar> */}
                {this.state.loading && <Loader />}
            </>
        )
    }
}

export default PaidEvents